import { Store } from "adminConsole/store";
import { FormikProps } from "formik";
import React from "react";
import { InputSelectField } from ".";

interface Props {
  id: string;
  stores: Store[];
  formikProps: FormikProps<any>;
}

export const StoreField: React.FC<Props> = ({ id, stores, formikProps }: Props) => {

  const storeOptions = stores.map((s) => ({
    label: `${s.name} (${s.code})`,
    value: s.id,
  }));

  return (
    <InputSelectField
      id={id}
      label="門市"
      options={storeOptions}
      formikProps={formikProps}
    />
  );
};
